import React, { useContext, useState, useRef, forwardRef, useEffect } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import copyToClipboard from 'copy-to-clipboard';
import { openLink } from '../../util/utilNative';
import Modal from '../../modal/Modal';

import iconCheck from '../../../asset/img/icon_check.svg';
import iconIng from '../../../asset/img/icon_ing.svg';
import iconOffPrepareing from '../../../asset/img/off_prepareing.svg';
import iconOffTransit from '../../../asset/img/off_transit.svg';
import iconOffComplete from '../../../asset/img/off_complete.svg';
import iconCopy from '../../../asset/img/icon_copy.svg';
import IconArrowUp from '../../../asset/img/ico_arrow_up.svg';
import iconArrowDown from '../../../asset/img/ico_arrow_down.svg';
import iconArrowRight from '../../../asset/img/ico_lb_right_arrow.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingTop: '6px',
  },
  dcList: {
    padding: '16px 16px 10px',
    borderRadius: '10px',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    margin: '0 10px 6px 12px',
  },
  dclItem: {
    width: '100%',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
  },
  delivInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  delivStatus: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '20px',
  },
  ordShop: {
    fontSize: theme.font.size15,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '0.87',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    paddingBottom: '12px',
  },
  ordInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: '2px',
  },
  ordTxt: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#666',
  },
  ordData: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'right',
    color: '#000',
  },
  divider: {
    backgroundColor: theme.color.divider.grey,
    width: '100%',
    height: '1px',
    margin: '12px 0 20px',
  },
  dividerP: {
    backgroundColor: theme.color.divider.grey,
    width: '100%',
    height: '1px',
    margin: '0 0 20px',
  },
  dividerInvoice: {
    backgroundColor: theme.color.divider.grey,
    width: '100%',
    height: '1px',
    margin: '10px 0 12px',
  },
  lineStatus: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: '7px',
    width: '100%',
    padding: '0 20px',
  },
  lineDashed: {
    borderWidth: '1px 0 0 0',
    borderStyle: 'dashed',
    borderColor: '#ddd',
  },
  iconCopyImg: {
    width: '18px',
    height: '18px',
    objectFit: 'contain',
    cursor: 'pointer',
    padding: '3px',
    display: 'inline-block',
    verticalAlign: 'top',
  },
  ordStatus: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'relative',
  },
  status: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: '1',
  },
  iconStatus: {
    width: '30px',
    height: '30px',
    objectFit: 'contain',
  },
  txtStatus: {
    fontSize: theme.font.size14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
    paddingTop: '4px',
  },
  txtStatusIng: {
    fontWeight: 'bold',
  },
  delivBtns: {
    // paddingTop: '20px',
  },
  dclBtn: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '0px',
    borderRadius: '0.375rem',
    backgroundColor: '#eee',
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.42',
    letterSpacing: 'normal',
    textAlign: 'center',
    minHeight: '32px',
    color: '#222',
    cursor: 'pointer',
  },
  dclBtnDisabled: {
    cursor: 'default',
    color: '#999',
  },
  delivModel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingTop: '10px',
  },
  delivModelP: {
    paddingTop: '0',
  },
  modelBtnArr: {
    backgroundColor: '#fff',
    border: '0',
    cursor: 'pointer',
  },
  iconArr: {
    width: '18px',
    height: '12px',
  },
  modelInfoList: {
    padding: '10px 0 14px',
  },
  modelInfoCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 16px',
    borderRadius: '10px',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    marginBottom: '6px',
  },
  modelInfoItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
  },
  modelInfoImg: {
    width: '50px',
    height: '50px',
    marginRight: '8px',
  },
  modelInfoNoImg: {
    padding: '5px',
  },
  prdInfoImg: {
    width: '100%',
    height: 'auto',
  },
  modelInfoBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  modelInfoDesc: {
    display: 'flex',
    flexDirection: 'column',
  },
  modelInfoTitle: {
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.29',
    letterSpacing: 'normal',
    textAlign: 'left',
    minHeight: '20px',
    color: '#000',
    margin: '0 4px 0 0',
  },
  modelInfoName: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.08',
    letterSpacing: 'normal',
    textAlign: 'left',
    minHeight: '17px',
    color: '#666',
  },
  modelInfoLink: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 0 10px 10px',
  },
  modelInfoLinkDisabled: {
    cursor: 'default',
  },
  outLinkImg: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    width: '16px',
    height: '16px',
  },
  dclGridHide: {
    display: 'none',
  },
  invoiceInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  invoiceInfoList: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: '2px',
  },
  invoiceTxt: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#666',
  },
  invoiceData: {
    fontSize: theme.font.size12,
    fontWeight: '400',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '16px',
    textAlign: 'right',
    color: '#000',
  },
  invoiceInfoData: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '8px',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    padding: '0',
  },
  invoicBtn: {
    fontSize: theme.font.size12,
    fontWeight: '700',
    lineHeight: '17px',
    letterSpacing: '0em',
    textDecoration: 'underline',
    textAlign: 'right',
    color: '#000',
  },
  invoicOutLinkImg: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    width: '12px',
    height: '12px',
    marginLeft: '4px',
  },
});

const isURLValid = (strUrl) => {
  let expUrl = /^http[s]?:\/\/([\S]{3,})/i;
  return expUrl.test(strUrl);
};

const DCLCard = withStyles(styles)(({ classes, item, index }) => {
  const context = useContext(DataContext);
  const isMobile = context.userAgent.deviceType === 'mobile';
  // H: 물류 | P: 택배 판단
  const delivType = item.deliv_type.toUpperCase();
  const isDelivTypeH = delivType === 'H';
  // H: 물류 - 알림톡이 아직 발송되지 않는 경우등은 message_seq가 아직 존재하지 않음
  // H: 물류 - message_seq가 없으면 tracking_url 존재하지 않음, But 배송상태는 들어옴
  // P: 택배 - message_seq가 없음
  const messageSeq = item?.message_seq ? true : false;

  // useEffect(() => {
  //   console.log('테스트 context', context);
  //   console.log('messageSeq', messageSeq);
  // }, []);

  /**
   * H: 물류 (배송 상세 보기) | P: 택배 (배송 확인하기)
   * 배송 관련 버튼
   */
  const btnArr = item?.buttons || [];
  // const isOdd = btnArr.length % 2 !== 0;
  const gridSizeFull = 12;
  // const gridSizeHalf = 6;
  const trackingUrlH = item?.tracking_url;

  // H: 물류(배송예정일) | P: 택배(배송예정일X)
  const delivWishY = item.deliv_wish_ymd.substr(0, 4);
  const delivWishM = item.deliv_wish_ymd.substr(4, 2);
  const delivWishD = item.deliv_wish_ymd.substr(6, 2);
  const delivWishYmd = `${delivWishY}-${delivWishM}-${delivWishD}`;

  // model_info (제품리스트, 화살표 펼침|닫힘)
  const [btnModelOpen, setBtnModelOpen] = useState(index === 0 ? true : false);
  const modelInfoArr = item?.model_info || [];
  const handleModelBtnArr = () => {
    if (modelInfoArr.length > 0) {
      setBtnModelOpen(!btnModelOpen);
    }
  };

  // model_info (제품 url)
  const noImgPath = `${window.location.protocol}//${window.location.host}/image/no_icon`;
  const handleImgError = (e) => {
    e.target.src = `${noImgPath}.svg`;
  };

  // JSON 데이터 KEY만 소문자로 변경
  const keyToLowerCase = (object) => {
    if (Array.isArray(object)) {
      // 리스트<맵> 형식으로 넘어오는 경우 처리
      object.forEach((item, index) => {
        object[index] = Object.fromEntries(
          Object.entries(item).map(([key, value]) => [key.toLowerCase(), value])
        );
      });
      return object;
    } else {
      // 맵 형식으로 넘어오는 경우 처리
      return Object.fromEntries(
        Object.entries(object).map(([key, value]) => [key.toLowerCase(), value])
      );
    }
  };

  /**
   * H: 물류 (주문완료 | 배송준비중 | 배송중 | 배송완료)
   * dev_status_type: "order | prepare | shipping | complete"
   */
  const DevStatusType = () => {
    const handleIconSrc = (props) => {
      switch (props) {
        case 'order': {
          return iconCheck;
        }
        case 'prepare': {
          if (item.dev_status_type === 'prepare') {
            return iconIng;
          } else if (item.dev_status_type === 'order') {
            return iconOffPrepareing;
          } else if (item.dev_status_type === 'shipping') {
            return iconCheck;
          }
        }
        case 'shipping': {
          if (item.dev_status_type === 'shipping') {
            return iconIng;
          } else if (['order', 'prepare'].includes(item.dev_status_type)) {
            return iconOffTransit;
          }
        }
        case 'complete': {
          if (item.dev_status_type === 'complete') {
            return iconCheck;
          } else if (['order', 'prepare', 'shipping'].includes(item.dev_status_type)) {
            return iconOffComplete;
          }
        }
        default:
          return iconCheck;
      }
    };

    return (
      <div className={classes.ordStatus}>
        <div className={classes.status}>
          <img
            className={classes.iconStatus}
            src={handleIconSrc('order')}
            alt="iconOrder"
          />
          <span
            className={[
              classes.txtStatus,
              item.dev_status_type === 'order' ? classes.txtStatusIng : null,
            ].join(' ')}
          >
            주문완료
          </span>
        </div>
        <div className={classes.status}>
          <img
            className={classes.iconStatus}
            src={handleIconSrc('prepare')}
            alt="iconPrepareing"
          />
          <span
            className={[
              classes.txtStatus,
              item.dev_status_type === 'prepare' ? classes.txtStatusIng : null,
            ].join(' ')}
          >
            배송준비중
          </span>
        </div>
        <div className={classes.status}>
          <img
            className={classes.iconStatus}
            src={handleIconSrc('shipping')}
            alt="iconTransit"
          />
          <span
            className={[
              classes.txtStatus,
              item.dev_status_type === 'shipping' ? classes.txtStatusIng : null,
            ].join(' ')}
          >
            배송중
          </span>
        </div>
        <div className={classes.status}>
          <img
            className={classes.iconStatus}
            src={handleIconSrc('complete')}
            alt="iconComplete"
          />
          <span
            className={[
              classes.txtStatus,
              item.dev_status_type === 'complete' ? classes.txtStatusIng : null,
            ].join(' ')}
          >
            배송완료
          </span>
        </div>
        <div className={classes.lineStatus}>
          <hr className={classes.lineDashed} />
        </div>
      </div>
    );
  };

  /**
   * P: 택배
   * invoice_no: "xxxx-xxxxx-xxxxx"
   * '-' 제외, 클립보드에 복사
   */
  // const InvoiceNo = () => {
  //   let invoiceNo = item?.invoice_no || '';
  //   let invoiceText = invoiceNo.replace(/-/g, '');

  //   return (
  //     <div className={classes.ordInfo}>
  //       <span className={classes.ordTxt}>운송장번호</span>
  //       <span className={classes.invoiceData}>
  //         {invoiceNo}
  //         <img
  //           className={classes.iconCopyImg}
  //           src={iconCopy}
  //           alt="iconCopy"
  //           onClick={() => {
  //             if (window?.navigator?.clipboard?.writeText) {
  //               window.navigator.clipboard.writeText(invoiceText);
  //             } else {
  //               copyToClipboard(invoiceText);
  //             }
  //           }}
  //         />
  //       </span>
  //     </div>
  //   );
  // };

  return (
    <div className={classes.dclItem}>
      <div className={classes.delivInfo}>
        <div className={classes.ordShop}>
          {item.ord_shop} 구매 {modelInfoArr.length}건
        </div>
        <div className={classes.ordInfo}>
          <span className={classes.ordTxt}>주문번호</span>
          <span className={classes.ordData}>{item.ord_header_no}</span>
        </div>
        {isDelivTypeH && (
          <div className={classes.ordInfo}>
            <span className={classes.ordTxt}>배송예정일</span>
            <span className={classes.ordData}>{delivWishYmd}</span>
          </div>
        )}
      </div>

      {isDelivTypeH && <div className={classes.divider}></div>}

      {/* H: 물류 (배송 상태) */}
      {isDelivTypeH && (
        <div className={classes.delivStatus}>
          <DevStatusType />
        </div>
      )}

      {/* H: 물류 (배송 상세 보기 - message_seq가 존재하면 필수) | P: 택배 (배송 확인하기 버튼 제거 - message_seq 없음)  */}
      {messageSeq && isDelivTypeH && (
        <div className={classes.delivBtns}>
          <Grid container spacing={1}>
            {btnArr.map((item, idx) => {
              // const gridSize = isDelivTypeH ? gridSizeHalf : gridSizeFull;
              const btnEnable = item.enable === 'Y' ? true : false, // 버튼 사용 여부(기본 값 Y)
                btnParamEnable = item.parameters.enable === 'Y' ? false : true, // link 사용 여부(기본 값 Y)
                btnType = item.type, // action_frontend
                btnAction = item.parameters.action; // 'external'
              const btnParamUrl = trackingUrlH;
              // const btnParamUrl = trackingUrlH.indexOf('chatbot=y') < 0
              //     ? trackingUrlH + '&chatbot=y'
              //     : trackingUrlH;

              return (
                <Grid
                  item
                  xs={gridSizeFull}
                  key={`dclGrid${idx}`}
                  className={!btnEnable ? classes.dclGridHide : ''}
                >
                  {btnEnable && (
                    <button
                      className={`${classes.dclBtn} ${
                        (!btnParamUrl || btnParamEnable) && classes.dclBtnDisabled
                      }`}
                      value={delivType}
                      disabled={!btnParamUrl || btnParamEnable}
                      onClick={(e) => {
                        // console.log(e.target.value);
                        openLink(context, btnAction, btnParamUrl);
                      }}
                    >
                      {item.label}
                    </button>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </div>
      )}

      {/* 주문 상품 정보 */}
      <div className={`${classes.delivModel} ${!isDelivTypeH && classes.delivModelP}`}>
        {btnModelOpen && (
          <div className={classes.modelInfoList}>
            {!isDelivTypeH && <div className={classes.dividerP}></div>}

            {modelInfoArr.map((it, idx) => {
              const productImgUrl = it?.product_image_url,
                productTitle = it.product_title,
                productName = it.product_name,
                productLinkUrl = it?.link?.product_link_url,
                productLinkType = it?.link?.type || 'external'; // 'external'
              // P: 택배 (invoice_info: [])
              let invoiceInfoArr = it?.invoice_info || [];
              invoiceInfoArr = keyToLowerCase(invoiceInfoArr);
              const invoiceInfoArrLen = invoiceInfoArr.length;

              const openProductLink = () => {
                if (productLinkUrl) {
                  openLink(context, productLinkType, productLinkUrl);
                }
              };

              return (
                <div key={`modelInfo${idx}`} className={classes.modelInfoCard}>
                  <div className={`${classes.modelInfoItem} ${
                    !productLinkUrl && classes.modelInfoLinkDisabled
                    } `}
                    onClick={() => openProductLink()}
                  >
                    <div
                      className={`${classes.modelInfoImg} ${
                        !productImgUrl && classes.modelInfoNoImg
                      }`}
                    >
                      {productImgUrl && isURLValid(productImgUrl) ? (
                        <img
                          className={classes.prdInfoImg}
                          src={productImgUrl}
                          onError={handleImgError}
                        />
                      ) : (
                        <img className={classes.prdInfoImg} src={`${noImgPath}.svg`} />
                      )}
                    </div>
                    <div className={classes.modelInfoBox}>
                      <div className={classes.modelInfoDesc}>
                        <div className={classes.modelInfoTitle}>{productTitle}</div>
                        <div className={classes.modelInfoName}>{productName}</div>
                      </div>
                      <div
                        className={`${classes.modelInfoLink} ${
                          !productLinkUrl && classes.modelInfoLinkDisabled
                        }`}
                      >
                        {productLinkUrl && (
                          <img className={classes.outLinkImg} src={iconArrowRight} />
                        )}
                      </div>
                    </div>
                  </div>

                  {/* 택배배송 운송장 번호 */}
                  {!isDelivTypeH && (
                    <div className={classes.invoiceInfoItem}>
                      <div className={classes.dividerInvoice}></div>
                      <div className={classes.invoiceInfoList}>
                        <span className={classes.invoiceTxt}>운송장 번호</span>
                        <div className={classes.invoiceInfo}>
                          {invoiceInfoArrLen > 0 ? (
                            invoiceInfoArr.map((it, idx) => {
                              const invoiceNo = it?.invoice_no || '';
                              const trackingUrlP = it?.tracking_url || '';
                              const openInvoicLink = () => {
                                if (trackingUrlP) {
                                  openLink(context, 'external', trackingUrlP);
                                }
                              };

                              return (
                                <button
                                  key={`invoiceInfo${idx}`}
                                  className={classes.invoiceInfoData}
                                  onClick={openInvoicLink}
                                >
                                  <div className={classes.invoicBtn}>{invoiceNo}</div>
                                  <img
                                    className={classes.invoicOutLinkImg}
                                    src={iconArrowRight}
                                  />
                                </button>
                              );
                            })
                          ) : (
                            <div className={classes.invoiceData}>
                              운송장 번호가 발급되지
                              <br />
                              않은 제품입니다.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <button
          disabled={modelInfoArr.length <= 0}
          className={classes.modelBtnArr}
          onClick={handleModelBtnArr}
        >
          <img
            className={classes.iconArr}
            src={btnModelOpen ? IconArrowUp : iconArrowDown}
          />
        </button>
      </div>
    </div>
  );
});

const DCL = (props) => {
  const { classes, data } = props;

  // useEffect(() => {
  //   console.log('테스트 DCL :: data', data);
  // }, []);

  // 최신 주문(번호)부터 내림차순으로 출력
  // const sortOrdNo = (list) => {
  //   const sortedList = list
  //     .sort((a, b) => {
  //       return a.ord_header_no - b.ord_header_no;
  //     })
  //     .reverse();
  //   return sortedList;
  // };

  // sortOrdNo(data.items);

  return (
    <div className={classes.root}>
      {
        data.items.sort((prevVal, nextVal) => {
          // deliv_wish_ymd가 존재하면 큰 deliv_wish_ymd가 앞으로 (최신->오래된 순서)
          // 둘중 하나가 deliv_wish_ymd가 존재하지 않으면 deliv_wish_ymd가 존재하지 않는게 뒤로
          // 둘다 deliv_wish_ymd가 존재하지 않으면 ord_header_no가 큰게(최신) 앞으로
          let numPrevWish = Number(prevVal?.deliv_wish_ymd || 0)
          let numNextWish = Number(nextVal?.deliv_wish_ymd || 0)
          let numPrevOrdNum = Number(prevVal?.ord_header_no || 0)
          let numNextOrdNum = Number(nextVal?.ord_header_no || 0)

          if (numPrevWish == 0 && numNextWish == 0) {
            return numNextOrdNum - numPrevOrdNum
          }
          else {
            return numNextWish - numPrevWish
          }
        }).map((it, idx) => {
          // const [headerNo, lineNo] = it.ord_header_no.split('-');
          // const lineNoArr = lineNo?.split('.');

          // const arr = Array.from({ length: 3 }, (v, i) => i);
          // let indexArr = arr.split('-').map(Number).join('');

          return (
            <div key={`dcList${idx}`} className={classes.dcList}>
              <DCLCard index={idx} item={it} />
            </div>
          );
        })
      }
    </div>
  );
};

export default withStyles(styles)(DCL);
